import { Header } from '@app/@utlity/model/request/base-request';
import { IRequestBody } from './i-request-body';
import { EmptyBody } from './empty-body';
export class EmptyBodyRequest implements IRequestBody {
  header: Header = new Header();
  meta: Object = new Object();
  body: EmptyBody = new EmptyBody();
}
